import InfoIcon from "@mui/icons-material/Info";
import { Box, IconButton, Tooltip } from "@mui/material";
import { NucleofectionPlateInfoState } from "features/WorklistTools/Nucleofection/state";
import { NumberField } from "features/WorklistTools/shared/components/NumberField";

interface NucleofectionTopUpVolumeProps {
  item: NucleofectionPlateInfoState;
  handleNucPlateInfoChanged: (key: string, value: any) => void;
}

export const NucleofectionTopUpVol = ({
  item,
  handleNucPlateInfoChanged,
}: NucleofectionTopUpVolumeProps) => {
  return (
    <NumberField
      style={{ width: `100%`}}
      id="nuc-top-up-vol"
      label={
        <Box sx={{ display: "inline-flex", alignItems: "center" }}>
          Nucleofection Top Up Vol (µL)
          <Tooltip
            arrow
            placement="top"
            title={
              <div>
                <p>Initial media top-up for Nucleofected cells.</p>
                <p>Note: different from Wash Vol</p>
              </div>
            }
          >
            <IconButton size="small">
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      }
      value={item.topUpVol}
      onChange={(value) =>
        handleNucPlateInfoChanged("topUpVol", parseInt(value))
      }
      disabled
    />
  );
};
